import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./app";
import { initTheme } from "./lib/theme";
import "./i18n/index";
import "./styles/globals.css";

initTheme();

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
